interface Step {
  id: number;
  label: string;
  status: "completed" | "active" | "pending";
}

export function ProcessStepper() {
  const steps: Step[] = [
    { id: 1, label: "START", status: "completed" },
    { id: 2, label: "CREATE APPLICATION", status: "completed" },
    { id: 3, label: "BUILD AND CONFIGURE", status: "active" },
    // { id: 4, label: "TEST", status: "pending" },
    { id: 5, label: "PUBLISH/DEPLOY", status: "pending" },
    // { id: 6, label: "MONITOR", status: "pending" },
  ];

  return (
    <div className="border-b px-4 md:px-8 overflow-x-auto">
      <div className="max-w-5xl mx-auto min-w-[480px] md:min-w-0">
        <div className="flex items-center">
          {steps.map((step, index) => {
            const isCompleted = step.status === "completed";
            const isActive = step.status === "active";
            const isLast = index === steps.length - 1;

            return (
              <div
                key={step.id}
                className={`flex items-center ${isLast ? "" : "flex-1"}`}
              >
                <div className="relative flex flex-col items-center w-8 pt-2">
                  <div
                    className={`
                      w-8 h-8 rounded-full flex items-center justify-center
                      text-sm font-bold flex-shrink-0 z-10
                      ${isCompleted
                        ? "bg-green-200 text-blue-600"
                        : isActive
                          ? "border-2 border-orange-500 text-blue-600 bg-white"
                          : "bg-gray-300 text-blue-600"
                      }
                    `}
                  >
                    {step.id}
                  </div>

                  <span
                    className={`
                      absolute top-10 left-1/2 -translate-x-1/2
                      text-[14px] font-medium text-center whitespace-nowrap
                      ${isActive
                        ? "text-orange-600"
                        : isCompleted
                          ? "text-black"
                          : "text-black"
                      }
                    `}
                  >
                    {step.label}
                  </span>
                </div>

                {!isLast && (
                  <div className="flex-1 h-[2px] mx-1">
                    <div
                      className={`
                        h-full w-full
                        ${isCompleted
                          ? "bg-green-500"
                          : isActive
                            ? "bg-orange-400"
                            : "bg-gray-300"
                        }
                      `}
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="h-8" />
      </div>
    </div>
  );
}